import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {TextArea} from '@/components/commons/textarea/TextArea'
import {FormInputTxtCounter} from '@/components/ui/form-atoms/FormAtoms'
import {useFormContext, useWatch} from 'react-hook-form'
import {useTranslation} from '@/translations/i18n'
import {AdministrativeActivitiesFormSchema} from '../administrative-activities-form/AdministrativeActivitiesForm'
import {NOTES_MAX_LENGTH} from '../../formSchemas'

export const NotesDescriptionField = () => {
    const {t} = useTranslation()

    const {
        register,
        control,
        formState: {errors}
    } = useFormContext<AdministrativeActivitiesFormSchema>()

    const watchNotesDescription = useWatch({control, name: 'notesDescription'})

    return (
        <Flexbox direction="column" gap={1} fullWidth>
            <TextArea
                placeholder={t('commons:description_dot')}
                rows={4}
                maxLength={NOTES_MAX_LENGTH}
                {...register('notesDescription')}
            />
            <FormInputTxtCounter
                limit={NOTES_MAX_LENGTH}
                count={watchNotesDescription?.length ?? 0}
                errorMessage={errors.notesDescription?.message}
            />
        </Flexbox>
    )
}
